import { render, staticRenderFns } from "./newEnquiryForm.vue?vue&type=template&id=012c2b6c"
import script from "./newEnquiryForm.vue?vue&type=script&lang=js"
export * from "./newEnquiryForm.vue?vue&type=script&lang=js"
import style0 from "./newEnquiryForm.vue?vue&type=style&index=0&id=012c2b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports